<template>
  <div
    id="data-management"
    class="page page-data-management"
  >
    <module-header />
    <div
      id="pageContent"
      class="page-content p-3"
    >
      <content-spinner :show="isLoading" />
      <folders-list />
    </div>
    <folder-modal
      v-if="folderModal.show"
      @on-folder-save="prepareData"
    />
  </div>
</template>

<script>

import {createNamespacedHelpers} from 'vuex';
import ContentSpinner from '../../../../core/components/ContentSpinner';
import TableCard from '../../components/TableCard';
import FolderModal from '../folder/modals/FolderModal';
import {UNSET_FOLDER_LIST} from '../../../../store/modules/data-management/mutation-types';
import NoContent from '../../../../core/components/NoContent';
import Breadcrumb from '../../../../core/components/Breadcrumb';
import moduleViewMixin from '../../../../core/mixins/module-view.mixin';
import FoldersList from '@/modules/DataManagement/views/module/components/FoldersList.vue';
import ModuleHeader from '@/modules/DataManagement/views/module/components/ModuleHeader.vue';

const {mapState, mapActions, mapMutations} = createNamespacedHelpers('dataManagement');
const {mapState: sidebarMapState, mapActions: sidebarMapActions} = createNamespacedHelpers('sidebar');

export default {
  name: 'ModuleView',
  components: {
    ModuleHeader,
    FoldersList,
    NoContent,
    FolderModal,
    TableCard,
    ContentSpinner,
    Breadcrumb,
  },
  mixins: [moduleViewMixin],
  data() {
    return {
      groups: [],
      moduleUuid: '',
      folderData: [],
      loading: false,
    };
  },
  computed: {
    ...mapState([
      'modules',
      'folders',
      'moduleData',
      'permissionTypes',
    ]),
    ...sidebarMapState({
      isLoading: state => state.isLoading,
    }),
    ...mapState({
      permissionItemTypes: state => state.permissionItemTypes,
      folderModal: state => state.folderModal,
    }),
  },
  methods: {
    ...mapActions([
      'getModules',
      'getModuleData',
      'getFolders',
      'addTable',
      'deleteFolder',
      'showFolderModal',
      'updateTable',
    ]),
    ...sidebarMapActions(['getModuleDetails']),
    ...mapMutations([UNSET_FOLDER_LIST]),
    // showEditFolderModal(folder) {
    //   this.showFolderModal(folder);
    // },
    // async prepareVisuals() {
    //   const vm = this
    //
    //   // Variable for save current dragging table block
    //   let draggingBlock;
    //   const setTableBlockEventListeners = () => {
    //     setTimeout(() => {
    //       const tableBlocks = document.querySelectorAll('.table-card-wrapper')
    //       tableBlocks.forEach(table => {
    //         table.addEventListener('dragstart', function (e) {
    //           e.dataTransfer.setData('tableIdToTransfer', JSON.stringify({ // Set data to transfer for drop event
    //             id: table.getAttribute('data-table-id')
    //           }))
    //           e.dataTransfer.effectAllowed = 'copyMove' // Change cursor while table block is in move state
    //           setTimeout(() => this.classList.add('dragging')) // Add dragging class with setTimout callback because without it dragging element has dropzone effect
    //           draggingBlock = e // Save current dragging block in context prepareVisuals function
    //         })
    //
    //         table.addEventListener('dragend', function () {
    //           this.classList.remove('dragging') // Remove dragging class when drag is end
    //         })
    //       })
    //     }) // Set event listeners in setTimeout callback because without it sometimes event listeners not working, reason is slow rendering.
    //   }
    //
    //   setTableBlockEventListeners() // Initial table card event listeners first time
    //
    //   const dragOver = function (e) {
    //     e.preventDefault()
    //   }
    //
    //   const dragEnter = function (e) {
    //
    //     const folderIdx = this.getAttribute('data-index') // Get folder index which is ready to drop.
    //     const tableFolderIdx = draggingBlock.target.getAttribute('data-folder-index') // Get index of dragging table folder.
    //
    //     if (!tableFolderIdx || tableFolderIdx === folderIdx) return false // Ignore to show drop zone, if dragging table is already exist in current table.
    //
    //     /**
    //      * Item is ready for drop, change cursor to copy and show dropzone.
    //      */
    //     e.dataTransfer.dropEffect = 'copy'
    //     this.classList.add('drag-enter')
    //   }
    //
    //   const dragLeave = function () {
    //     this.classList.remove('drag-enter') // Remove drop zone when drag is cancelled.
    //   }
    //
    //   const drop = async function (e) {
    //     e.preventDefault();
    //     this.classList.remove('drag-enter') // Remove drop zone when user drops the table.
    //
    //     const transferredTable = JSON.parse(e.dataTransfer.getData('tableIdToTransfer')) // Get information about dropped table
    //     const transferredFromFolder = vm.folders.data.find(f => f.tables.some(t => t.entityGuid === transferredTable.id)) // Get folder of dropped table
    //     const transferredToFolderId = this.getAttribute('data-folder-id') // Get id of folder, where moving new table.
    //     const transferredToFolder = vm.folders.data.find(f => f.folderGuid === transferredToFolderId) // Get object of new folder
    //     const table = transferredFromFolder.tables.find(t => t.entityGuid === transferredTable.id) // Get dropped table object
    //
    //     if (transferredFromFolder.folderGuid === transferredToFolderId) return false // Ignore to drop table, if table already exist in same folder.
    //
    //     const updatedTable = {
    //       ...table, folderGuid: transferredToFolderId
    //     }
    //
    //     vm.loading = true
    //
    //     const {success, body} = await vm.updateTable({table: updatedTable, updateTableOnly: true})
    //
    //     if (success) {
    //       transferredFromFolder.tables = transferredFromFolder.tables.filter(t => t.entityGuid !== transferredTable.id)
    //       transferredToFolder.tables.push(updatedTable)
    //
    //       setTableBlockEventListeners() // Reset table block eventListeners.
    //
    //       vm.$toasted.success(`Table "${table.displayName}" moved to "${transferredToFolder.folderName}" folder`, {
    //         duration: TOASTER_DURATION,
    //       })
    //       vm.loading = false
    //       await vm.prepareData()
    //
    //       return true
    //     } else {
    //       vm.$toasted.error(body.ErrorMessage, {
    //         duration: TOASTER_DURATION,
    //       })
    //     }
    //     vm.loading = false
    //
    //     return false
    //   }
    //
    //   // ADD Event listeners for folder rows
    //   const folderContents = document.querySelectorAll('.folder-content')
    //   folderContents.forEach(folderContent => {
    //     folderContent.addEventListener('dragover', dragOver)
    //     folderContent.addEventListener('dragover', dragEnter)
    //     folderContent.addEventListener('dragleave', dragLeave)
    //     folderContent.addEventListener('drop', drop)
    //   })
    // },
    async prepareData() {
      await this.getModuleDetails(this.$route.params.moduleUuid);
    },
  },
  destroyed() {
    this[UNSET_FOLDER_LIST]();
  },
};
</script>

<style lang="scss">
.drag-enter {
  background: darken(#e8e8e8, 3);
  border: 2px dashed;
}

.dragging {

  .card-table {
    background: darken(#e8e8e8, 3);
    border: 2px dashed;

    &:hover {
      box-shadow: unset;
    }
  }

  .action-wrapper,
  .card-title {
    display: none;
  }
}
</style>
